import React, { useEffect, useState } from "react";
import * as urlService from "../view/urlService";
import { connect } from "react-redux";
import { debug, sortObjectsByAlphabet } from "../utils";
import { useLocation, useHistory } from "react-router-dom";
import Select from 'react-select';

const timeIntervalsFilter = [
    { id: 0, name: "Custom", value: "0custom" },
    { id: 1, name: "Last 5 mins", value: "1last5mins" },
    { id: 2, name: "Last 1 hr", value: "2last1hr" },
    { id: 3, name: "Last 24 hrs", value: "3last24hrs" },
    { id: 4, name: "Last 3 days", value: "4last3days" },
    { id: 5, name: "Last 7 days", value: "5last7days" },
    { id: 6, name: "Last Month", value: "6lastmonth" },
    { id: 7, name: "Last 60 days", value: "7last60days" },
    { id: 8, name: "Last 90 days", value: "8last90days" }
]

function TimeIntervalDropdown({ timeIntervals }) {

    const history = useHistory();
    const location = useLocation();
    const [timeIntervalId, setTimeIntervalId] = useState(1);


    useEffect(() => {
        const filters = urlService.getFilterQueryString();
        const params = urlService.getParams();

        if (params.notification === "1" || (params.f_startTime && params.f_endTime)) {
            setTimeIntervalId(0);
            return;
        }

        // Default behavior for "Last 5 mins" if no time filters set
        let dt = new Date();
        dt.setMinutes(dt.getMinutes() - 5);
        let dtUnixTimestamp = Math.floor(dt.getTime());
        if (timeIntervalId === 1 && !filters.includes("f_startTime")) {
            history.push({
                pathname: history.pathname,
                search: urlService.updateComparisonFilters('startTime', dtUnixTimestamp)
            })
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [location.search])


    const onTimeIntervalChange = (selectedOption) => {
        const value = Number(selectedOption.value);
        setTimeIntervalId(value);
        getDateFilterUnixFormat(value);
    }

    const getDateFilterUnixFormat = (value) => {

        if (value === 0) {
            return;
        }

        let dt = new Date();
        switch (value) {
            case "1":
            case 1:
                dt.setMinutes(dt.getMinutes() - 5);
                break;
            case "2":
            case 2:
                dt.setHours(dt.getHours() - 1);
                break;
            case "3":
            case 3:
                dt.setHours(dt.getHours() - 24);
                break;
            case "4":
            case 4:
                dt.setDate(dt.getDate() - 3);
                break;
            case "5":
            case 5:
                dt.setDate(dt.getDate() - 7);
                break;
            case "6":
            case 6:
                dt.setDate(dt.getDate() - 30);
                break;
            case "7":
            case 7:
                dt.setDate(dt.getDate() - 60);
                break;
            case "8":
            case 8:
                dt.setDate(dt.getDate() - 90);
                break;
            default:
                dt.setMinutes(dt.getMinutes() - 5);
                break;
        }

        let dtUnixTimestamp = Math.floor(dt.getTime());
        const params = new URLSearchParams(window.location.search);
        params.delete('notification');
        params.delete('f_endTime');
        params.set('f_startTime', String(dtUnixTimestamp));
        params.set('p_page', '0');

        history.push({
            pathname: history.pathname,
            search: params.toString()
        });

    }


    const timeIntervalsCopy = sortObjectsByAlphabet(timeIntervalsFilter, 'value');

    const options = timeIntervalsCopy.map(ti => ({ value: ti.id, label: ti.name }));

    return (
        <Select
            className="oct_selectsearch-v2"
            classNamePrefix="oct-selectsearchsub-v2"
            value={options.find(opt => opt.value === timeIntervalId) || options.find(opt => opt.value === 1)}
            onChange={onTimeIntervalChange}
            options={options}
            isSearchable={false}
            placeholder="Last 5 mins"
        />
    )

}

function mapStateToProps(state) {
    debug("TimeIntervalsDropdown mapStateToProps", state);
    const recentViolationsPage = state.recentViolationsPage;
    return {
        timeIntervals: recentViolationsPage.timeIntervals || []
    };
}

export default connect(mapStateToProps)(TimeIntervalDropdown);
